import React from 'react';
import Distribution from '../components/Distribution';
import Sustainability from '../components/Sustainability';

const DistributionPage = () => {
  return (
    <div>
      <Distribution />
      <Sustainability />
    </div>
  );
};

export default DistributionPage;

